/**
 * Synchronous “likely logged in” check for first paint (PWA cold start) before Supabase hydrates.
 * Must match `auth.storageKey` in supabase.ts and the inline script in public/index.html.
 */
export const SUPABASE_AUTH_STORAGE_KEY = 'supabase.auth.token';

export function hasStoredSupabaseSession(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(SUPABASE_AUTH_STORAGE_KEY);
    if (!raw || raw.length < 8) return false;
    const o = JSON.parse(raw) as Record<string, unknown>;
    if (typeof o.access_token === 'string' && o.access_token.length > 0) return true;
    const current = o.currentSession as Record<string, unknown> | undefined;
    if (current && typeof current.access_token === 'string' && current.access_token.length > 0) return true;
    return false;
  } catch {
    return false;
  }
}
